import React, { useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const ACCENT = COLORS.primary_color_shade6 || "#039BE5";
const MODAL_RADIUS = 16;

const MODAL_STYLES = `
  .mdl-change-password.modal-dialog {
    margin: 0.75rem auto 1.25rem;
    display: flex;
    align-items: center;
  }
  .mdl-change-password .modal-content {
    border: none;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
  }
  .mdl-change-password .form-control {
    border-radius: 10px;
    border: 1px solid #e5e7eb;
  }
  .mdl-change-password .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const ChangePassword = ({ actionClose }) => {
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [newPass, setNewPass] = useState("");
  const [confPass, setConfPass] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setShow(false);
    if (typeof actionClose === "function") actionClose();
  };

  const handleSubmit = async () => {
    if (!newPass.trim()) {
      setError("Please enter a new password.");
      return;
    }
    if (!confPass.trim()) {
      setError("Please confirm the new password.");
      return;
    }
    if (newPass !== confPass) {
      setError("New password and confirm password must match.");
      return;
    }

    const staffId = SessionManager.getStaffDetails()?.staff_id;
    const schoolCode = SessionManager.getSchoolCode();
    if (!staffId || !schoolCode) {
      myToast.notify_warning("Staff session not found. Please log in again.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}changeStaffPassword.php`;
      const response = await axios.get(url, {
        params: {
          staff_id: staffId,
          school_code: schoolCode,
          new_password: newPass,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Password updated successfully.");
        handleClose();
      } else {
        setError(
          response.data?.api_remark || "Could not update password. Please try again."
        );
      }
    } catch (err) {
      console.error("Change password error:", err);
      myToast.notify_error("An error occurred while updating the password.");
    } finally {
      setLoading(false);
    }
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <>
      <style>{MODAL_STYLES}</style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        dialogClassName="mdl-change-password"
        centered
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${ACCENT} 0%, ${COLORS.primary_color_shade7 || "#0288D1"} 100%)`,
            borderBottom: "none",
            color: "#fff",
          }}
        >
          <Modal.Title style={{ fontWeight: 800, color: "#fff" }}>
            <i className="fa fa-key" style={{ marginRight: 8 }} />
            Change Password
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: 18 }}>
          {loading ? (
            <MyLoader />
          ) : (
            <div className="row g-3">
              <div className="col-12">
                <Form.Label style={{ fontWeight: 700, fontSize: 13 }}>
                  New Password
                </Form.Label>
                <Form.Control
                  type="password"
                  autoComplete="new-password"
                  placeholder="Enter new password"
                  value={newPass}
                  onChange={(e) => {
                    setNewPass(e.target.value);
                    setError("");
                  }}
                  autoFocus
                />
              </div>
              <div className="col-12">
                <Form.Label style={{ fontWeight: 700, fontSize: 13 }}>
                  Confirm Password
                </Form.Label>
                <Form.Control
                  type="password"
                  autoComplete="new-password"
                  placeholder="Re-enter new password"
                  value={confPass}
                  onChange={(e) => {
                    setConfPass(e.target.value);
                    setError("");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSubmit();
                  }}
                />
              </div>
              {error ? (
                <div className="col-12" style={{ color: "#dc2626", fontSize: 12 }}>
                  {error}
                </div>
              ) : null}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e5e7eb" }}>
          <div className="d-flex justify-content-end w-100 gap-2">
            <Button variant="light" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading}
              style={{ background: ACCENT, borderColor: ACCENT, fontWeight: 700 }}
            >
              Update Password
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePassword;
